import { useUserCarInfo } from '@/entities/car';
import { SaveStationButton } from '@/features/favorites-toggle';
import { DEFAULT_FUEL_AMOUNT, DEFAULT_FUEL_EFFICIENCY } from '@/shared/consts';
import { useBoundStore } from '@/shared/store';
import { BottomSheetListItem, SavingsCalculationGuideItem } from '@/shared/ui';
import { useNaverMapStore } from '@/widgets/naver-map';
import StationChip from './StationChip';

const BottomSheetList = () => {
	const { carInfo } = useUserCarInfo();
	const minZoomLevel = useNaverMapStore((store) => store.minZoomLevel);
	const currentZoomLevel = useNaverMapStore((store) => store.currentZoomLevel);
	const sortedStations = useNaverMapStore((s) => s.sortedStations);
	const filter = useNaverMapStore((s) => s.filter);
	const showSavingsDescription = filter === 'savings';
	const cheapestStation = sortedStations.reduce(
		(cheapest, station) =>
			cheapest.price < station.price ? cheapest : station,
		sortedStations[0],
	);
	const currentSnapPoint = useBoundStore((store) => store.currentSnapPoint);
	const scrollable =
		currentSnapPoint === 3 ? 'overflow-y-auto' : 'overflow-hidden';

	if (minZoomLevel > currentZoomLevel) {
		return (
			<p className="py-10 text-center text-mantang-gray-500 text-sm">
				주유소를 보려면 지도를 더 확대해주세요
			</p>
		);
	}

	if (!sortedStations.length) {
		return (
			<p className="py-10 text-center text-mantang-gray-500 text-sm">
				해당 지역에는 주유소가 없어요
			</p>
		);
	}

	return (
		<>
			{showSavingsDescription && (
				<SavingsCalculationGuideItem
					efficiency={carInfo?.efficiency ?? DEFAULT_FUEL_EFFICIENCY}
					averageFuelAmount={
						carInfo?.average_fuel_amount ?? DEFAULT_FUEL_AMOUNT
					}
				/>
			)}
			<ul
				className={`scrollbar-hide flex flex-1 flex-col items-stretch ${scrollable}`}
			>
				{sortedStations.map((station) => {
					const isCheapestStation = station.id === cheapestStation.id;
					const isNearestStation = !!station.isNearestStation;

					return (
						<BottomSheetListItem
							key={station.id}
							stationId={station.id}
							stationName={station.stationName}
							address={station.address}
							distance={station.distanceFromUser}
							price={station.price}
							extraDistance={station.extraDistance}
							savings={station.savings}
							showSavingsDescription={showSavingsDescription}
							actionSlot={<SaveStationButton stationId={station.id} />}
							chips={[
								isCheapestStation && (
									<StationChip key="cheapest" type="cheapest" />
								),
								isNearestStation && (
									<StationChip key="nearest" type="nearest" />
								),
							].filter(Boolean)}
						/>
					);
				})}
			</ul>
		</>
	);
};

export default BottomSheetList;
